<template>
    <router-view></router-view>
</template>

<script lang="ts"></script>

<style></style>
